<template>
    <div class="card-wrap">
        <div class="card-header">
            <img :src="data.logo" />
        </div>
        <div class="card-body">
            <p class="card-body-header">{{data.organizationName}}</p>
            <p class="card-body-content">
                {{resofString(data.orgInformation)}}
                <span
                    class="card-body-check"
                    @click="checkDetail(data.id)"
                >查看详情</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  methods: {
    resofString: function (string) {
      string = string.replace(/(<([^>]+)>|\w|{([^>]+)})|\s|@|-|@|-|一|、|/g, '')
      if (string && string.length > 50) {
        let temp = string.slice(0, 50)
        temp = temp + '...'
        return temp
      } else if (string && string <= 50) {
        return string
      } else {
        return ''
      }
    },
    checkDetail: function (id) {
      this.$router.push(`/article/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-wrap {
    transition: box-shadow 0.3s ease-in-out;
    &:hover {
        box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.08);
    }
    height: 210px;
    width: 310px;
    background: white;
    border: 1px solid #e5e5e5;
    padding: 15px;
    padding-top: 0px;
    .card-header {
        height: 64px;
        width: 100%;
        border-bottom: 1px solid #d8d8d8;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
            height: 35px;
            object-fit: contain;
        }
    }
    .card-body {
        .card-body-header {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 16px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
            margin-top: 27px;
            text-align: left;
        }
        .card-body-content {
            width: 100%;
            height: 64px;
            margin-top: 16px;
            position: relative;
            font-size: 14px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 22px;
            text-align: left;
            span {
                position: absolute;
                bottom: -10px;
                right: 2px;
            }
        }
        .card-body-check {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 82, 188, 1);
            line-height: 12px;
            cursor: pointer;
        }
    }
}
</style>
